import AuthFunctions from "../classes/AuthFunctions";

export default function auth({ next, router }) {

  if (AuthFunctions.isUserGuest()) {
    return router.push({ name: 'home' }).then(() => router.app.snotifyError('Ошибка авторизации'));
  }

  return next();
}
